import { 
  Component, 
  OnInit, 
  Input, 
  Output, 
  ViewChild, 
  ElementRef, 
  EventEmitter, 
  HostListener, 
  forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-custom-team-selection',
  templateUrl: './custom-team-selection.component.html',
  styleUrls: ['./custom-team-selection.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CustomTeamSelectionComponent),
      multi: true
    }
  ]
})
export class CustomTeamSelectionComponent implements OnInit {
  @Input() placeholder: string = "Choose Your Team";
  @Input() isLoggedIn: boolean;
  @Input() items: any[] = [];
  @Input() optionKeyForValue: string = "value";
  @Input() optionKeyForLabel: string = "label";
  @Output() selectedValueChange: EventEmitter<any> = new EventEmitter<any>();
  @Output() choseSpectate: EventEmitter<any> = new EventEmitter<any>();
  @Output() auth: EventEmitter<any> = new EventEmitter<any>();
  @ViewChild('dropdown') dropdown: ElementRef;

  private innerValue: any;
  private onChange: (_: any) => void = () => { };
  private onTouched: () => void = () => { };

  // guest: boolean;

  constructor(private elementRef: ElementRef) { }

  ngOnInit(): void {
    // this.route.queryParams.subscribe(params => {
    //   if (params['guest']) {
    //     this.guest = params['guest'];
    //     this.router.navigate(["."], { relativeTo: this.route })
    //   }
    // });
  }

  // ngAfterViewInit(): void {
  //   if (this.guest) this.onItemClick({team_name:'',kt_team_id:'new'});
  // }

  // spectate() {
  //   this.choseSpectate.emit("");
  // }

  newTeam() {
    this.onItemClick({team_name:'',kt_team_id:'new'});
  }

  // needTeams() {
  //   sessionStorage.removeItem('choseSpectator');
  //   this.auth.emit("");
  // }

  toggleDropdown() {
    this.dropdown.nativeElement.classList.toggle('active');
  }

  onItemClick(item: any) {
    this.innerValue = item[this.optionKeyForValue];
    this.onChange(this.innerValue);
    this.onTouched();
    this.selectedValueChange.emit(this.innerValue);
    this.toggleDropdown();
    this.placeholder = item[this.optionKeyForLabel]
  }

  @HostListener('document:click', ['$event'])
  onClick(event: Event) {
    const dropdown = this.elementRef.nativeElement.querySelector('.custom-dropdown');
    if (!dropdown.contains(event.target as Node)) {
      dropdown.classList.remove('active');
    }
  }

  // ControlValueAccessor methods
  writeValue(value: any): void {
    this.innerValue = value;
  }

  registerOnChange(fn: (_: any) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }
}
